(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  function initTFHeadingAlignment() {
    const root = document.querySelector('results-list');
    if (!root) return;
    const title = Array.from(document.querySelectorAll('main h1, #MainContent h1')).find(el => el.getBoundingClientRect().width > 0);
    if (!title) return;
    let frame;
    const align = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        let grid = root.querySelector('.product-grid');
        if (!grid || !grid.getBoundingClientRect().width) grid = document.querySelector('.tf-mini-grid, .tf-accessory-type-grid');
        const heading = title.closest('.tf-inner-title, .tf-shop-heading');
        if (!grid || !heading || !grid.getBoundingClientRect().width) return;
        const gridRect = grid.getBoundingClientRect();
        heading.style.setProperty('max-width', gridRect.width + 'px');
        heading.style.setProperty('margin-inline', 'auto');
        const prior = parseFloat(heading.style.left) || 0;
        const rect = heading.getBoundingClientRect();
        const shift = gridRect.left + gridRect.width / 2 - rect.left - rect.width / 2 + prior;
        heading.style.position = 'relative';
        heading.style.left = shift + 'px';
        root.querySelectorAll('.tf-heading-identity').forEach(group => {
          group.style.setProperty('--tf-heading-shift', '0px');
        });
      });
    };
    const resize = new ResizeObserver(align);
    resize.observe(root);
    resize.observe(title);
    new MutationObserver(align).observe(root, { childList: true, subtree: true });
    window.addEventListener('resize', align, { passive: true });
    document.fonts.ready.then(align);
    align();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initTFHeadingAlignment, { once: true });
  else initTFHeadingAlignment();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tf-marketplace"] && !Shopify.designMode) return;
  try {
    
  class TFMarketplace extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.grid = this.querySelector('[data-market-grid]');
      this.search = this.querySelector('[data-market-search]');
      this.sort = this.querySelector('[data-market-sort]');
      this.count = this.querySelector('[data-market-count]');
      this.empty = this.querySelector('[data-market-empty]');
      const messageNode = this.querySelector('[data-market-messages]');
      if (!this.grid || !this.search || !this.sort || !this.count || !this.empty || !messageNode) return;
      this.messages = JSON.parse(messageNode.textContent);
      this.taxonomy = JSON.parse(this.querySelector('[data-market-taxonomy]').textContent);
      this.categoryPaths = new Map();
      for (const group of this.taxonomy) {
        this.categoryPaths.set(group.id, [group.id]);
        for (const category of group.children) {
          this.categoryPaths.set(category.id, [group.id, category.id]);
          for (const type of category.children) this.categoryPaths.set(type.id, [group.id, category.id, type.id]);
        }
      }
      const legacy = { optics: 'get-your-nvgs', tactical: 'vests-plate-carriers', bags: 'backpacks-gun-bags', accessories: 'gun-accessories' };
      for (const [key, value] of Object.entries(legacy)) this.categoryPaths.set(key, this.categoryPaths.get(value));
      this.groupSelect = this.querySelector('[data-market-group]');
      this.categorySelect = this.querySelector('[data-market-subcategory]');
      this.typeSelect = this.querySelector('[data-market-type]');
      this.fillCategories(this.groupSelect, this.taxonomy);
      this.cards = [...this.grid.querySelectorAll('[data-market-card]')].map(node => ({
        node,
        categories: (node.dataset.category || '').split('|').flatMap(id => this.categoryPaths.get(id.trim()) || []),
        price: Number(node.dataset.price),
        order: Number(node.dataset.order),
        expires: Number(node.dataset.expires || 0),
        text: this.normalize(node.textContent)
      }));
      this.category = 'all';
      this.controller = new AbortController();
      this.addEventListener('input', event => {
        if (event.target === this.search) this.update();
      }, { signal: this.controller.signal });
      this.addEventListener('change', event => {
        if ([this.groupSelect, this.categorySelect, this.typeSelect].includes(event.target)) this.syncCategories(event.target);
        if ([this.sort, this.search, this.groupSelect, this.categorySelect, this.typeSelect].includes(event.target)) this.update();
      }, { signal: this.controller.signal });
      this.addEventListener('click', event => {
        if (!(event.target instanceof Element)) return;
        const button = event.target.closest('[data-market-category], [data-market-reset]');
        if (!button || !this.contains(button)) return;
        if (button.hasAttribute('data-market-reset')) {
          this.search.value = '';
          this.sort.value = 'featured';
          this.groupSelect.value = '';
          this.syncCategories(this.groupSelect);
          this.update();
          this.search.focus();
          return;
        }
        this.category = button.dataset.marketCategory;
        this.update();
      }, { signal: this.controller.signal });
      this.querySelector('[data-market-tools]').hidden = false;
      this.update();
      if (this.cards.some(card => card.expires)) this.expiryTimer = setInterval(() => this.update(), 30000);
    }

    disconnectedCallback() {
      clearInterval(this.expiryTimer);
      this.controller?.abort();
      this.controller = null;
    }

    fillCategories(select, choices) {
      select.replaceChildren(select.options[0].cloneNode(true));
      select.options[0].selected = true;
      for (const choice of choices) select.add(new Option(choice.label, choice.id));
    }

    syncCategories(changed) {
      const group = this.taxonomy.find(node => node.id === this.groupSelect.value);
      if (changed === this.groupSelect) this.fillCategories(this.categorySelect, group?.children || []);
      const category = group?.children.find(node => node.id === this.categorySelect.value);
      if (changed !== this.typeSelect) this.fillCategories(this.typeSelect, category?.children || []);
      this.categorySelect.disabled = !group;
      this.querySelector('[data-market-subcategory-wrap]').hidden = !group;
      this.typeSelect.disabled = !category?.children.length;
      this.querySelector('[data-market-type-wrap]').hidden = this.typeSelect.disabled;
      this.category = this.typeSelect.value || this.categorySelect.value || this.groupSelect.value || 'all';
    }

    normalize(value) {
      return String(value).normalize('NFD').replace(/\p{M}/gu, '').toLowerCase().replace(/ς/g, 'σ').trim();
    }

    update() {
      const terms = this.normalize(this.search.value).split(/\s+/).filter(Boolean);
      const mode = this.sort.value;
      const sorted = [...this.cards].sort((a, b) => {
        if (mode === 'price-asc') return a.price - b.price || a.order - b.order;
        if (mode === 'price-desc') return b.price - a.price || a.order - b.order;
        return a.order - b.order;
      });
      let visible = 0;
      for (const card of sorted) {
        const matches = (!card.expires || card.expires * 1000 > Date.now()) && (this.category === 'all' || card.categories.includes(this.category)) && terms.every(term => card.text.includes(term));
        card.node.hidden = !matches;
        if (matches) visible += 1;
        this.grid.append(card.node);
      }
      for (const button of this.querySelectorAll('[data-market-category]')) {
        button.setAttribute('aria-pressed', String(button.dataset.marketCategory === this.category));
      }
      this.count.textContent = (visible === 1 ? this.messages.one : this.messages.many).replace('{count}', String(visible));
      this.empty.hidden = visible !== 0;
      this.grid.hidden = visible === 0;
      const reset = this.querySelector('.tf-marketplace__results [data-market-reset]');
      if (reset) reset.hidden = !terms.length && this.category === 'all' && mode === 'featured';
    }
  }
  if (!customElements.get('tf-marketplace')) customElements.define('tf-marketplace', TFMarketplace);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tf-milsim-loadout"] && !Shopify.designMode) return;
  try {
    

/* Milsim's local bundle builder. Previewing and confirming are separate actions. */
if (!customElements.get('tf-milsim-builder')) {
  customElements.define('tf-milsim-builder', class extends HTMLElement {
    connectedCallback() {
      if (this.builderAbort) return;
      this.builderAbort = new AbortController();
      const signal = this.builderAbort.signal;
      this.groups = new Map();
      this.confirmed = new Map();
      this.moneySource = this.querySelector('[data-milsim-base-total]');
      this.summaryList = this.querySelector('[data-bundle-list]');
      this.rewardPreviousTotal = null;
      this.rewardPulseTimers = new Map();
      this.storageKey = `tf-milsim-bundle-v1:${this.id || 'milsim-ready'}`;
      this.strings = {};
      try { this.strings = JSON.parse(this.querySelector('[data-bundle-i18n]')?.textContent || '{}'); } catch (_) { /* Use the English defaults. */ }

      this.querySelectorAll('.tf-milsim__card[data-milsim-block-id], [data-bundle-extra][data-milsim-block-id]').forEach(element => {
        const id = element.dataset.milsimBlockId;
        if (!id || this.groups.has(id)) return;
        const panels = Array.from(element.querySelectorAll('[data-milsim-option-panel]'));
        if (!panels.length) return;
        this.groups.set(id, { element, panels });
        const selector = element.querySelector('[data-milsim-option-selector]');
        if (selector) selector.hidden = false;
        panels.forEach(panel => panel.querySelectorAll('[data-bundle-confirm]').forEach(button => {
          button.disabled = !this.readPanel(panel);
        }));
      });


      this.initializeColors();

      // Keep connectors attached to the cards as their content and viewport change.
      const layoutConnectors = () => {
        const stage = this.querySelector('.tf-milsim__stage');
        const svg = this.querySelector('.tf-milsim__lines');
        if (!stage || !svg || !matchMedia('(min-width:761px)').matches) return;
        const frame = stage.getBoundingClientRect();
        if (!frame.width) return;
        this.querySelectorAll('.tf-milsim__gear-column .tf-milsim__card[data-milsim-block-id]').forEach(card => {
          const index = card.className.match(/tf-milsim__card--(\d+)/)?.[1];
          const path = index && svg.querySelector('.tf-milsim__line--' + index);
          const marker = this.querySelector('[data-bundle-marker="' + card.dataset.milsimBlockId + '"]');
          if (!path || !marker) return;
          const box = card.getBoundingClientRect();
          const target = marker.getBoundingClientRect();
          const left = card.classList.contains('tf-milsim__card--left');
          const startX = ((left ? box.right : box.left) - frame.left) / frame.width * 1000;
          const endX = (target.left + target.width / 2 - frame.left) / frame.width * 1000;
          const startY = box.top + 40 - frame.top;
          const endY = target.top + target.height / 2 - frame.top;
          const bendX = (startX + endX) / 2;
          path.setAttribute('d', 'M ' + startX + ' ' + startY + ' H ' + bendX + ' V ' + endY + ' H ' + endX);
        });
      };
      this.layoutObserver = new ResizeObserver(layoutConnectors);
      this.querySelectorAll('.tf-milsim__stage,.tf-milsim__gear-column,.tf-milsim__card').forEach(node => this.layoutObserver.observe(node));
      window.addEventListener('resize', layoutConnectors, { signal });
      requestAnimationFrame(layoutConnectors);

      this.addEventListener('change', event => {
        const part = event.target.closest('[data-bundle-part]');
        if (part) {
          this.commitUniform(part.closest('[data-milsim-option-panel]'));
          return;
        }
        const quantity = event.target.closest('[data-bundle-quantity]');
        if (quantity) {
          const group = this.groups.get(quantity.dataset.bundleQuantity);
          const panel = group?.panels[0];
          if (panel && this.setPanelQuantities(panel, [Number(quantity.value)])) this.preview(group.element.dataset.milsimBlockId, panel.dataset.milsimOptionPanel);
          return;
        }
        const select = event.target.closest('[data-color-select]');
        if (!select || !this.contains(select)) return;
        const control = select.closest('[data-color-choice]');
        const ref = control?.dataset.colorRef;
        const group = ref ? this.groups.get(ref) : this.groups.get(control?.closest('[data-milsim-block-id]')?.dataset.milsimBlockId);
        const panel = ref ? group?.panels[0] : control?.closest('[data-milsim-option-panel]');
        const slot = this.colorPanels.get(panel)?.slots.get(Number(control?.dataset.productIndex || 0));
        if (!slot || !group) return;
        const candidates = slot.data.variants.filter(variant => variant.color === select.value);
        const current = slot.variant;
        // Keep any other option (such as size) whenever that combination exists.
        const variant = candidates.find(candidate => candidate.options.every((value, index) => index === slot.data.colorIndex || value === current.options[index])) || candidates[0];
        if (!variant) { select.value = current.color; return; }
        slot.variant = variant;
        this.syncColorPanel(panel);
        if (panel.querySelector('[data-bundle-part]')) this.commitUniform(panel);
        else this.preview(group.element.dataset.milsimBlockId, panel.dataset.milsimOptionPanel);
      }, { signal });

      // Native details preserve touch and no-JS access; hover is an enhancement.
      this.addonTimers = new Map();
      const closeAddons = except => this.querySelectorAll('.tf-milsim__addon[open]').forEach(detail => {
        if (detail !== except) detail.open = false;
      });
      const placeAddon = detail => {
        if (!detail.open) return;
        const trigger = detail.querySelector('summary').getBoundingClientRect();
        const rail = detail.closest('.tf-milsim__addons-rail').getBoundingClientRect();
        const flyout = detail.querySelector('.tf-milsim__addon-flyout');
        const width = flyout.getBoundingClientRect().width || 285;
        const left = Math.max(12, Math.min(trigger.left, document.documentElement.clientWidth - width - 12));
        const offset = getComputedStyle(detail).direction === 'rtl' ? rail.right - left - width : left - rail.left;
        detail.style.setProperty('--addon-offset', offset + 'px');
        detail.style.setProperty('--addon-top', (trigger.bottom - rail.top + 6) + 'px');
      };
      window.addEventListener('resize', () => this.querySelectorAll('.tf-milsim__addon[open]').forEach(placeAddon), { signal });
      this.querySelectorAll('.tf-milsim__addon').forEach(detail => {
        detail.addEventListener('pointerenter', event => {
          clearTimeout(this.addonTimers.get(detail));
          if (event.pointerType !== 'mouse') return;
          closeAddons(detail);
          detail.open = true;
          placeAddon(detail);
        }, { signal });
        detail.addEventListener('pointerleave', event => {
          if (event.pointerType !== 'mouse') return;
          clearTimeout(this.addonTimers.get(detail));
          this.addonTimers.set(detail, setTimeout(() => {
            const keyboardFocus = detail.contains(document.activeElement) && document.activeElement.matches(':focus-visible');
            if (!keyboardFocus && !detail.matches(':hover')) detail.open = false;
            this.addonTimers.delete(detail);
          }, 180));
        }, { signal });
        detail.addEventListener('toggle', () => { if (detail.open) { closeAddons(detail); placeAddon(detail); } }, { signal });
        detail.addEventListener('focusout', event => {
          if (!detail.contains(event.relatedTarget) && !detail.matches(':hover')) detail.open = false;
        }, { signal });
      });
      document.addEventListener('pointerdown', event => {
        if (!event.target.closest('.tf-milsim__addon')) closeAddons();
      }, { signal });
      this.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        const detail = event.target.closest('.tf-milsim__addon[open]');
        if (!detail) return;
        event.preventDefault();
        detail.open = false;
        detail.querySelector('summary')?.focus();
      }, { signal });

      this.addEventListener('click', event => {
        const addonSummary = event.target.closest('.tf-milsim__addon > summary');
        if (addonSummary && event.detail > 0 && matchMedia('(hover:hover) and (pointer:fine)').matches) {
          event.preventDefault();
          const detail = addonSummary.parentElement;
          closeAddons(detail);
          detail.open = true;
          placeAddon(detail);
          return;
        }
        const addonClose = event.target.closest('[data-addon-close]');
        if (addonClose) {
          const detail = addonClose.closest('.tf-milsim__addon');
          detail.open = false;
          detail.querySelector('summary')?.focus();
          return;
        }
        const accessory = event.target.closest('[data-accessory-add]');
        if (accessory && this.contains(accessory)) {
          event.preventDefault();
          if (!accessory.disabled) this.confirm(accessory.dataset.accessoryAdd, '1');
          return;
        }
        const preview = event.target.closest('[data-milsim-option-button]');
        if (preview && this.contains(preview)) {
          const card = preview.closest('[data-milsim-block-id]');
          this.preview(card?.dataset.milsimBlockId, preview.dataset.milsimOptionButton);
          return;
        }
        const confirm = event.target.closest('[data-bundle-confirm]');
        if (confirm && this.contains(confirm)) {
          event.preventDefault();
          if (confirm.disabled) return;
          const card = confirm.closest('[data-milsim-block-id]');
          const panel = confirm.closest('[data-milsim-option-panel]');
          this.confirm(card?.dataset.milsimBlockId, panel?.dataset.milsimOptionPanel);
          return;
        }
        const remove = event.target.closest('[data-bundle-remove]');
        if (remove && this.contains(remove)) {
          const id = remove.dataset.bundleRemove;
          const old = this.confirmed.get(id);
          if (!old) return;
          const nextFocusId = remove.closest('[data-bundle-entry]')?.nextElementSibling?.dataset.bundleEntry
            || remove.closest('[data-bundle-entry]')?.previousElementSibling?.dataset.bundleEntry;
          this.confirmed.delete(id);
          this.render();
          this.persist();
          this.announce('removed', '{title} removed from your bundle. Selected total: {total}.', { title: old.titles.join(' + '), total: this.formatMoney(this.total()) });
          const nextRemove = Array.from(this.querySelectorAll('[data-bundle-remove]')).find(button => button.dataset.bundleRemove === nextFocusId);
          if (nextRemove) nextRemove.focus();
          else this.querySelector('[data-bundle-summary]')?.focus();
          return;
        }
        const clear = event.target.closest('[data-bundle-clear]');
        if (clear && this.contains(clear)) {
          this.confirmed.clear();
          this.render();
          this.persist();
          this.announce('cleared', 'Your bundle has been cleared.');
          this.querySelector('[data-bundle-summary]')?.focus();
        }
      }, { signal });

      this.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        const button = event.target.closest('[data-milsim-option-button]');
        if (!button || !this.contains(button)) return;
        const buttons = Array.from(button.parentElement.querySelectorAll('[data-milsim-option-button]'));
        if (!buttons.length) return;
        const index = buttons.indexOf(button);
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1
          : (index + (event.key === 'ArrowRight' ? 1 : -1) + buttons.length) % buttons.length;
        event.preventDefault();
        buttons[next].focus();
        buttons[next].click();
      }, { signal });

      // This pilot stores choices only. It never sends a cart request or unlocks checkout.
      this.addEventListener('submit', event => event.preventDefault(), { signal });
      this.querySelectorAll('.tf-milsim__buy-bundle').forEach(button => { button.disabled = true; });
      this.querySelectorAll('[data-milsim-cart-form]').forEach(form => {
        form.dataset.ready = 'false';
        form.querySelectorAll('input').forEach(input => { input.disabled = true; });
      });

      this.restore();
      this.render();
    }

    text(key, fallback, values = {}) {
      let result = typeof this.strings[key] === 'string' ? this.strings[key] : fallback;
      Object.entries(values).forEach(([name, value]) => { result = result.split(`{${name}}`).join(String(value)); });
      return result;
    }


    initializeColors() {
      this.colorPanels = new Map();
      let vestGallery = {};
      try { vestGallery = JSON.parse(this.querySelector('[data-vest-gallery]')?.textContent || '{}'); } catch (_) {}
      this.groups.forEach(group => group.panels.forEach(panel => {
        const original = this.readPanel(panel, true);
        if (!original) return;
        const slots = new Map();
        panel.querySelectorAll('[data-color-choice]:not([data-color-ref])').forEach(control => {
          const select = control.querySelector('[data-color-select]');
          try {
            const data = JSON.parse(control.querySelector('[data-color-data]')?.textContent || 'null');
            const index = Number(control.dataset.productIndex || 0);
            if (!data || !Number.isSafeInteger(index) || index < 0 || index >= original.ids.length
              || !Array.isArray(data.variants) || !Number.isSafeInteger(data.colorIndex) || data.colorIndex < 0) return;
            data.variants = data.variants.filter(variant => variant && /^\d+$/.test(String(variant.id))
              && typeof variant.color === 'string' && variant.color.trim()
              && Number.isSafeInteger(variant.price) && variant.price >= 0
              && Array.isArray(variant.options) && variant.options.every(value => typeof value === 'string')
              && typeof variant.url === 'string' && /^(https?:\/\/|\/[^/])/.test(variant.url));
            if (group.element.dataset.milsimKind === 'vest') data.variants.forEach(variant => {
              const preview = vestGallery[String(variant.id)];
              if (preview && typeof preview.image === 'string' && /^(https?:)?\/\//.test(preview.image)) {
                variant.image = preview.image;
                variant.previewZoom = preview.zoom;
                variant.previewOrigin = preview.origin;
              }
            });
            const variant = data.variants.find(candidate => String(candidate.id) === original.ids[index]);
            if (!variant) return;
            slots.set(index, { control, data, variant, quantity: original.quantities[index] });
            if (select) select.disabled = false;
          } catch (_) { /* Keep the server-rendered variant when data is incomplete. */ }
        });
        if (!slots.size) return;
        const basePrice = original.price - Array.from(slots.values()).reduce((sum, slot) => sum + slot.variant.price * slot.quantity, 0);
        this.colorPanels.set(panel, { slots, basePrice, original });
        this.syncColorPanel(panel);
      }));
    }

    syncVariantImage(container, image, title) {
      if (!container) return;
      const img = container.querySelector('img');
      const pending = container.querySelector('.tf-milsim__image-pending, .tf-milsim__support-image-pending');
      const usable = typeof image === 'string' && /^(https?:)?\/\//.test(image);
      if (img) {
        img.hidden = !usable;
        if (usable) { img.src = image; img.removeAttribute('srcset'); img.alt = title; }
      } else if (usable) {
        const next = document.createElement('img');
        next.src = image; next.alt = title; next.width = 160; next.height = 160; next.loading = 'lazy';
        const target = container.querySelector('.tf-milsim__support-product') || container;
        target.prepend(next);
      }
      if (pending) pending.hidden = usable;
    }

    syncColorPanel(panel) {
      const state = this.colorPanels.get(panel);
      if (!state) return;
      const { original, slots } = state;
      const ids = [...original.ids], titles = [...original.titles], images = [...original.images];
      const quantities = [...original.quantities];
      const unitPrices = JSON.parse(panel.dataset.bundleUnitPrices || '[]');
      let price = state.basePrice;
      slots.forEach((slot, index) => {
        const { variant, data, control, quantity } = slot;
        const title = data.title || original.titles[index];
        ids[index] = String(variant.id);
        titles[index] = `${title} — ${variant.color}`;
        images[index] = variant.image || null;
        if (index === 0 && panel.closest('[data-milsim-kind="vest"]')) {
          panel.style.setProperty('--main-zoom', String(variant.previewZoom || 1.65));
          panel.style.setProperty('--main-origin', variant.previewOrigin || '50% 50%');
        }
        price += variant.price * quantity;
        quantities[index] = quantity;
        unitPrices[index] = variant.price;
        const select = control.querySelector('[data-color-select]');
        if (select) select.value = variant.color;
        panel.querySelectorAll(`[data-variant-link="${index}"]`).forEach(link => {
          link.href = variant.url;
          if (!link.closest('.tf-milsim__reason')) this.syncVariantImage(link, variant.image, title);
          link.querySelectorAll('.tf-milsim__colour, [data-variant-color]').forEach(node => { node.textContent = variant.color; });
        });
        panel.querySelectorAll(`[data-variant-status="${index}"]`).forEach(node => {
          const label = variant.available ? (control.dataset.viewLabel || this.dataset.viewLabel) : (control.dataset.soldLabel || this.dataset.soldLabel);
          if (label) node.textContent = label;
        });
        panel.querySelectorAll(`[data-variant-price="${index}"]`).forEach(node => {
          node.textContent = quantity > 1 ? `${quantity} × ${this.formatMoney(variant.price)} = ${this.formatMoney(variant.price * quantity)}` : this.formatMoney(variant.price);
        });
      });
      panel.dataset.bundleIds = JSON.stringify(ids);
      panel.dataset.bundleQuantities = JSON.stringify(quantities);
      panel.dataset.bundleUnitPrices = JSON.stringify(unitPrices);
      panel.dataset.bundleTitles = JSON.stringify(titles);
      panel.dataset.bundleImages = JSON.stringify(images);
      panel.dataset.bundlePriceCents = String(price);
      panel.dataset.priceLabel = this.formatMoney(price);
      if (slots.has(0)) {
        panel.dataset.variantId = String(slots.get(0).variant.id);
        panel.dataset.priceCents = String(slots.get(0).variant.price);
      }
      const group = Array.from(this.groups.values()).find(value => value.panels.includes(panel));
      if (!group) return;
      if (!panel.hidden) {
        const headingPrice = group.element.querySelector('.tf-milsim__card-top .tf-milsim__price');
        if (headingPrice) headingPrice.textContent = this.formatMoney(panel.querySelector('[data-bundle-part]') ? (this.readPanel(panel)?.price || 0) : price);
      }
      this.querySelectorAll('[data-accessory-ref]').forEach(detail => {
        if (detail.dataset.accessoryRef !== group.element.dataset.milsimBlockId) return;
        const slot = slots.get(0);
        if (!slot) return;
        const { variant, data, quantity } = slot;
        detail.querySelectorAll('[data-bundle-quantity]').forEach(select => { select.value = String(quantity); });
        const title = data.title || original.titles[0];
        detail.querySelectorAll('[data-color-select]').forEach(select => { select.value = variant.color; select.disabled = false; });
        const product = detail.querySelector('.tf-milsim__addon-product');
        if (product) {
          product.href = variant.url;
          this.syncVariantImage(product, variant.image, title);
          const color = product.querySelector('small');
          if (color) color.textContent = variant.color + (quantity > 1 ? ` · ×${quantity}` : '');
          const amount = product.querySelector('b');
          if (amount) amount.textContent = this.formatMoney(variant.price * quantity);
        }
        const link = detail.querySelector('.tf-milsim__addon-actions > a');
        if (link) link.href = variant.url;
        const thumb = detail.querySelector('.tf-milsim__addon-thumb');
        if (thumb) {
          thumb.hidden = !variant.image;
          if (variant.image) { thumb.src = variant.image; thumb.removeAttribute('srcset'); }
        }
      });
    }

    commitUniform(panel) {
      const id = panel?.closest('[data-milsim-block-id]')?.dataset.milsimBlockId;
      if (!id || !panel.querySelector('[data-bundle-part]')) return;
      const selected = this.readPanel(panel);
      if (selected) this.confirmed.set(id, selected);
      else this.confirmed.delete(id);
      this.render();
      this.persist();
      this.announce('uniform_updated', 'Uniform updated. Selected total: {total}.', { total: this.formatMoney(this.total()) });
      this.dispatchEvent(new CustomEvent('milsim:bundle-change', { bubbles: true, detail: { blockId: id, option: panel.dataset.milsimOptionPanel, totalCents: this.total(), count: this.count() } }));
    }

    setPanelQuantities(panel, quantities) {
      const group = Array.from(this.groups.values()).find(value => value.panels.includes(panel));
      const id = group?.element.dataset.milsimBlockId;
      const editable = ['accessory_6', 'belt_pistol', 'belt_rifle'].includes(id);
      const current = this.readPanel(panel, true);
      if (!current || !Array.isArray(quantities) || quantities.length !== current.ids.length
        || quantities.some(qty => !Number.isSafeInteger(qty) || qty < 1 || qty > 10)) return false;
      if (JSON.stringify(quantities) === JSON.stringify(current.quantities)) return true;
      if (!editable) return false;
      const state = this.colorPanels.get(panel);
      if (state?.slots.has(0)) {
        state.slots.get(0).quantity = quantities[0];
        this.syncColorPanel(panel);
      } else {
        const unitPrice = current.price / current.quantities[0];
        if (current.ids.length !== 1 || !Number.isSafeInteger(unitPrice)) return false;
        const price = unitPrice * quantities[0];
        panel.dataset.bundleQuantities = JSON.stringify(quantities);
        panel.dataset.bundlePriceCents = String(price);
        panel.dataset.priceLabel = this.formatMoney(price);
        panel.querySelectorAll('[data-variant-price="0"]').forEach(node => { node.textContent = this.formatMoney(price); });
        this.querySelectorAll('[data-accessory-ref]').forEach(detail => {
          if (detail.dataset.accessoryRef !== id) return;
          detail.querySelectorAll('[data-bundle-quantity]').forEach(select => { select.value = String(quantities[0]); });
          const amount = detail.querySelector('.tf-milsim__addon-product b');
          if (amount) amount.textContent = this.formatMoney(price);
          const color = detail.querySelector('.tf-milsim__addon-product small');
          if (color) color.textContent = color.textContent.replace(/ · ×\d+$/, '') + (quantities[0] > 1 ? ' · ×' + quantities[0] : '');
        });
      }
      return true;
    }

    restorePanelVariants(panel, ids, indices) {
      const current = this.readPanel(panel, true);
      if (!current || !Array.isArray(ids) || !ids.length || ids.some(id => typeof id !== 'string')) return false;
      const parts = Array.from(panel.querySelectorAll('[data-bundle-part]'));
      const positions = indices || ids.map((_, index) => index);
      if (!Array.isArray(positions) || positions.length !== ids.length || new Set(positions).size !== positions.length
        || positions.some(index => !Number.isSafeInteger(index) || index < 0 || index >= current.ids.length)
        || (!parts.length && ids.length !== current.ids.length)) return false;
      const slots = this.colorPanels.get(panel)?.slots;
      const pending = [];
      for (let index = 0; index < ids.length; index += 1) {
        const sourceIndex = positions[index];
        const slot = slots?.get(sourceIndex);
        if (slot) {
          const variant = slot.data.variants.find(candidate => String(candidate.id) === ids[index]);
          if (!variant) return false;
          pending.push([slot, variant]);
        } else if (ids[index] !== current.ids[sourceIndex]) return false;
      }
      pending.forEach(([slot, variant]) => { slot.variant = variant; });
      parts.forEach(input => { input.checked = positions.includes(Number(input.dataset.bundlePart)); });
      this.syncColorPanel(panel);
      return true;
    }

    sameSelection(left, right) {
      return Boolean(left && right && left.option === right.option
        && JSON.stringify(left.ids) === JSON.stringify(right.ids)
        && JSON.stringify(left.quantities) === JSON.stringify(right.quantities));
    }

    readPanel(panel, allParts = false) {
      if (!panel || panel.dataset.bundleValid !== 'true') return null;
      try {
        const ids = JSON.parse(panel.dataset.bundleIds || '[]');
        const quantities = JSON.parse(panel.dataset.bundleQuantities || '[]');
        const titles = JSON.parse(panel.dataset.bundleTitles || '[]');
        const images = JSON.parse(panel.dataset.bundleImages || '[]');
        const price = Number(panel.dataset.bundlePriceCents);
        const parts = Array.from(panel.querySelectorAll('[data-bundle-part]'));
        if (!Array.isArray(ids) || !ids.length || !Array.isArray(quantities) || quantities.length !== ids.length
          || !Array.isArray(titles) || titles.length !== ids.length || !Array.isArray(images)
          || !Number.isSafeInteger(price) || price < 0) return null;
        const validIndices = parts.length ? parts.filter(input => !input.disabled && (allParts || input.checked)).map(input => Number(input.dataset.bundlePart)) : ids.map((_, index) => index);
        if (!validIndices.length || validIndices.some(index => !/^\d+$/.test(String(ids[index]))
          || !Number.isSafeInteger(Number(quantities[index])) || Number(quantities[index]) < 1
          || typeof titles[index] !== 'string' || !titles[index].trim())) return null;
        const indices = parts.length && !allParts ? parts.filter(input => input.checked && !input.disabled).map(input => Number(input.dataset.bundlePart)) : ids.map((_, index) => index);
        if (!indices.length) return null;
        const unitPrices = JSON.parse(panel.dataset.bundleUnitPrices || '[]');
        const selectedPrice = parts.length && !allParts ? indices.reduce((sum, index) => sum + Number(unitPrices[index]) * quantities[index], 0) : price;
        if (!Number.isSafeInteger(selectedPrice) || selectedPrice < 0) return null;
        return {
          panel,
          option: panel.dataset.milsimOptionPanel,
          indices,
          ids: indices.map(index => String(ids[index])),
          quantities: indices.map(index => Number(quantities[index])),
          titles: indices.map(index => titles[index]),
          images: indices.map(index => typeof images[index] === 'string' && /^(https?:)?\/\//.test(images[index]) ? images[index] : null),
          price: selectedPrice
        };
      } catch (_) { return null; }
    }

    preview(id, option) {
      const group = this.groups.get(id);
      const panel = group?.panels.find(item => item.dataset.milsimOptionPanel === option);
      if (!panel) return;
      group.panels.forEach(item => { item.hidden = item !== panel; });
      group.element.dataset.milsimSelectedOption = option;
      group.element.querySelectorAll('[data-milsim-option-button]').forEach(button => {
        button.setAttribute('aria-pressed', String(button.dataset.milsimOptionButton === option));
      });
      const price = group.element.querySelector('.tf-milsim__card-top .tf-milsim__price');
      if (price && panel.dataset.priceLabel) price.textContent = panel.dataset.priceLabel;
      const reason = Array.from(this.querySelectorAll('[data-milsim-choice-block]')).find(item => item.dataset.milsimChoiceBlock === id);
      if (reason) {
        const heading = reason.querySelector('h3');
        const points = reason.querySelector('.tf-milsim__choice-points');
        const template = panel.querySelector('[data-milsim-option-points]');
        if (heading && panel.dataset.reasonTitle) heading.textContent = panel.dataset.reasonTitle;
        if (points && template) points.replaceChildren(template.content.cloneNode(true));
      }
      if (this.restoring) this.updateGroupState(id);
      else {
        const hadFrontPouch = this.confirmed.has('accessory_6');
        this.render();
        this.persist();
        if (hadFrontPouch && !this.confirmed.has('accessory_6')) this.announce('front_pouch_removed', 'The extra front pouch was removed: the Standard Reaper already includes three magazine pockets.');
      }
      this.dispatchEvent(new CustomEvent('milsim:option-preview', { bubbles: true, detail: { blockId: id, option } }));
    }

    confirm(id, option) {
      if (!this.accessoryAllowed(id)) return;
      const group = this.groups.get(id);
      const selection = this.readPanel(group?.panels.find(panel => panel.dataset.milsimOptionPanel === option));
      if (!selection) return;
      const previous = this.confirmed.get(id);
      const unchanged = this.sameSelection(previous, selection);
      if (unchanged) this.confirmed.delete(id);
      else this.confirmed.set(id, selection);
      this.render();
      this.persist();
      this.announce(unchanged ? 'removed' : previous ? 'updated' : 'added',
        unchanged ? '{title} removed from your bundle. Selected total: {total}.' : previous ? '{title} replaces your previous choice. Selected total: {total}.' : '{title} added to your bundle. Selected total: {total}.',
        { title: selection.titles.join(' + '), total: this.formatMoney(this.total()) });
      this.dispatchEvent(new CustomEvent('milsim:bundle-change', { bubbles: true, detail: { blockId: id, option, totalCents: this.total(), count: this.count() } }));
    }

    total() { return Array.from(this.confirmed.values()).reduce((sum, item) => sum + item.price, 0); }
    count() { return Array.from(this.confirmed.values()).reduce((sum, item) => sum + item.quantities.reduce((a, b) => a + b, 0), 0); }

    formatMoney(cents) {
      const format = this.moneySource?.dataset.milsimMoneyFormat || '';
      const token = format.match(/\{\{\s*(\w+)\s*\}\}/);
      const formats = {
        amount: [2, ',', '.'], amount_no_decimals: [0, ',', '.'],
        amount_with_comma_separator: [2, '.', ','], amount_no_decimals_with_comma_separator: [0, '.', ','],
        amount_with_apostrophe_separator: [2, "'", '.'], amount_no_decimals_with_space_separator: [0, ' ', ','],
        amount_with_space_separator: [2, ' ', ','], amount_with_period_and_space_separator: [2, ' ', '.']
      };
      if (token && formats[token[1]]) {
        const [precision, separator, decimal] = formats[token[1]];
        const pieces = (cents / 100).toFixed(precision).split('.');
        pieces[0] = pieces[0].replace(/\B(?=(\d{3})+(?!\d))/g, separator);
        return format.replace(token[0], pieces.join(decimal));
      }
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: this.moneySource?.dataset.milsimCurrency || 'EUR'
      }).format(cents / 100);
    }

    updateGroupState(id) {
      const group = this.groups.get(id);
      if (!group) return;
      const selection = this.confirmed.get(id);
      group.element.classList.toggle('has-bundle-selection', Boolean(selection));
      if (selection) group.element.dataset.bundleConfirmedOption = selection.option;
      else delete group.element.dataset.bundleConfirmedOption;
      group.panels.forEach(panel => {
        const parts = Array.from(panel.querySelectorAll('[data-bundle-part]'));
        if (!parts.length) return;
        parts.forEach(input => { input.checked = Boolean(selection?.option === panel.dataset.milsimOptionPanel && (selection.indices || [0, 1]).includes(Number(input.dataset.bundlePart))); });
        const price = group.element.querySelector('.tf-milsim__card-top .tf-milsim__price');
        if (price) price.textContent = this.formatMoney(selection?.price || 0);
      });
      group.panels.forEach(panel => panel.querySelectorAll('[data-bundle-confirm]').forEach(button => {
        const item = this.readPanel(panel);
        const selected = this.sameSelection(selection, item);
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-pressed', String(selected));
        button.disabled = !item || !this.accessoryAllowed(id);
        const title = item?.titles.join(' + ') || group.element.dataset.milsimCategory || '';
        button.setAttribute('aria-label', this.text(selected ? 'remove_label' : 'add_label', selected ? 'Remove {title} from bundle' : 'Add {title} to bundle', { title }));
        const label = button.closest('.tf-milsim__quick-wrap')?.querySelector('[data-bundle-confirm-label]');
        if (label) label.textContent = this.text(selected ? 'added_button' : 'add_button', selected ? 'Added' : 'Add to bundle');
      }));


      this.querySelectorAll('[data-accessory-ref]').forEach(detail => {
        if (detail.dataset.accessoryRef !== id) return;
        const item = this.readPanel(group.panels[0]);
        const selected = this.sameSelection(selection, item);
        detail.classList.toggle('is-selected', selected);
        const button = detail.querySelector('[data-accessory-add]');
        if (!button) return;
        button.disabled = !item || !this.accessoryAllowed(id);
        button.setAttribute('aria-pressed', String(selected));
        const title = item?.titles.join(' + ') || group.element.dataset.milsimCategory || '';
        button.setAttribute('aria-label', this.text(selected ? 'remove_label' : 'add_label', selected ? 'Remove {title} from bundle' : 'Add {title} to bundle', { title }));
        const label = button.querySelector('[data-accessory-add-label]');
        if (label) label.textContent = this.text(selected ? 'added_button' : 'add_button', selected ? 'Added' : 'Add to bundle');
        const sign = button.querySelector('[data-accessory-add-sign]');
        if (sign) sign.textContent = selected ? '✓' : '+';
      });

      this.querySelectorAll('[data-bundle-marker]').forEach(marker => {
        if (marker.dataset.bundleMarker !== id) return;
        if (!marker.dataset.bundleOriginalLabel) marker.dataset.bundleOriginalLabel = marker.getAttribute('aria-label') || group.element.dataset.milsimCategory || '';
        marker.classList.toggle('is-selected', Boolean(selection));
        const thumbs = marker.querySelector('[data-bundle-thumbs]');
        if (thumbs) {
          thumbs.replaceChildren();
          if (selection) selection.images.slice(0, 2).forEach((url, index) => {
            if (!url) return;
            const img = document.createElement('img');
            img.src = url;
            img.alt = selection.titles[index] || selection.titles[0];
            img.width = 48;
            img.height = 48;
            img.loading = 'eager';
            thumbs.append(img);
          });
        }
        const check = marker.querySelector('[data-bundle-check]');
        if (check) check.hidden = !selection;
        marker.setAttribute('aria-label', selection
          ? this.text('marker_selected', '{category}: {title}, selected in your bundle', { category: marker.dataset.bundleOriginalLabel, title: selection.titles.join(' + ') })
          : marker.dataset.bundleOriginalLabel);
      });
    }

    accessoryAllowed(id) {
      const group = this.groups.get(id);
      if (!group?.element.hasAttribute('data-requires-body-premium')) return true;
      const carrier = Array.from(this.groups.entries()).find(([, value]) => value.element.dataset.milsimKind === 'vest');
      if (!carrier) return false;
      const [carrierId, carrierGroup] = carrier;
      const preview = carrierGroup.panels.find(panel => !panel.hidden);
      const chosen = this.confirmed.get(carrierId);
      const required = 'invader-gear-reaper-qrb-plate-carrier-black';
      return preview?.dataset.productHandle === required && (!chosen || chosen.panel.dataset.productHandle === required);
    }

    syncCarrierAccessories() {
      const allowed = this.accessoryAllowed('accessory_6');
      this.querySelectorAll('[data-requires-body-premium]').forEach(element => {
        if (!allowed && element.contains(document.activeElement)) {
          this.querySelector('[data-milsim-kind="vest"] [data-milsim-option-button][aria-pressed="true"]')?.focus();
        }
        element.toggleAttribute('hidden', !allowed);
        if (!allowed && element.tagName === 'DETAILS') element.open = false;
      });
      if (!allowed) this.confirmed.delete('accessory_6');
    }

    selectionSections() {
      const categoryOrder = { glasses: 0, helmet: 1, mask: 1, vest: 2, uniform: 3, shirt: 3, trousers: 3, gloves: 4, belt: 5, boots: 6 };
      const owners = new Map();
      const sections = new Map();
      const cards = Array.from(this.groups, ([id, group]) => ({ id, group }))
        .filter(({ group }) => group.element.matches('.tf-milsim__card'));
      cards.forEach(({ id, group }, index) => {
        const kind = group.element.dataset.milsimKind || '';
        const section = { id, label: group.element.dataset.milsimCategory || '', order: categoryOrder[kind] ?? 20 + index, entries: [], price: 0 };
        sections.set(id, section);
        owners.set(id, id);
        group.element.querySelectorAll('[data-accessory-ref]').forEach(addon => {
          if (!owners.has(addon.dataset.accessoryRef)) owners.set(addon.dataset.accessoryRef, id);
        });
      });
      const belt = cards.find(({ group }) => group.element.dataset.milsimKind === 'belt');
      this.groups.forEach((group, id) => {
        const selected = this.confirmed.get(id);
        if (!selected) return;
        const isComms = group.element.matches('.tf-milsim__essential-item');
        const owner = owners.get(id) || (group.element.matches('.tf-milsim__belt-card') ? belt?.id : null) || (isComms ? 'comms' : 'accessories');
        if (!sections.has(owner)) sections.set(owner, { id: owner, label: isComms ? group.element.dataset.milsimCategory : this.text('selections_accessories', 'Essential accessories'), order: 99, entries: [], price: 0 });
        const section = sections.get(owner);
        section.entries.push({ id, group, selected });
        section.price += selected.price;
      });
      return Array.from(sections.values()).filter(section => section.entries.length).sort((a, b) => a.order - b.order).map(section => {
        section.entries.sort((a, b) => Number(b.id === section.id) - Number(a.id === section.id));
        return section;
      });
    }

    selectionProduct(selected, index) {
      const sourceIndex = selected.indices?.[index] ?? index;
      const slot = this.colorPanels?.get(selected.panel)?.slots.get(sourceIndex);
      const variant = slot?.data.variants.find(item => String(item.id) === String(selected.ids[index]));
      const color = variant?.color || '';
      const savedTitle = selected.titles[index];
      const baseTitle = variant && typeof slot.data.title === 'string' && slot.data.title.trim() ? slot.data.title : savedTitle;
      const colorSuffix = color ? ' — ' + color : '';
      const title = colorSuffix && baseTitle.endsWith(colorSuffix) ? baseTitle.slice(0, -colorSuffix.length) : baseTitle;
      let candidateUrl = variant?.url || '';
      if (!slot) {
        // A colorless product may use its original link only while the panel still represents the confirmed variant.
        try {
          const currentIds = JSON.parse(selected.panel.dataset.bundleIds || '[]');
          if (String(currentIds[sourceIndex]) === String(selected.ids[index])) {
            candidateUrl = selected.panel.querySelector('[data-variant-link="' + sourceIndex + '"]')?.getAttribute('href') || '';
          }
        } catch (_) { /* Incomplete variant data produces a non-link row. */ }
      }
      const url = /^(https?:\/\/|\/[^/])/.test(candidateUrl) ? candidateUrl : '';
      return { title, color, image: selected.images[index], quantity: selected.quantities[index], url };
    }

    renderSelectionGroups() {
      if (!this.summaryList) return;
      this.summaryList.replaceChildren();
      const sections = this.selectionSections();
      if (!sections.length) {
        const empty = document.createElement('p');
        empty.className = 'tf-milsim__bundle-empty';
        empty.textContent = this.text('selections_empty', 'Your setup starts here. Press + on an item to add it.');
        this.summaryList.append(empty);
        return;
      }
      sections.forEach((section, sectionIndex) => {
        const category = document.createElement('section');
        category.className = 'tf-milsim__selection-category';
        category.dataset.selectionCategory = section.id;
        const heading = document.createElement('header');
        const title = document.createElement('h3');
        title.id = this.id + '-selected-category-' + sectionIndex;
        title.textContent = section.label;
        category.setAttribute('aria-labelledby', title.id);
        const subtotal = document.createElement('span');
        subtotal.className = 'tf-milsim__category-subtotal';
        subtotal.textContent = this.formatMoney(section.price);
        heading.append(title, subtotal);
        const list = document.createElement('ul');
        list.className = 'tf-milsim__selection-rows';
        section.entries.forEach(({ id, group, selected }) => {
          const entry = document.createElement('li');
          entry.dataset.bundleEntry = id;
          entry.className = 'tf-milsim__bundle-entry';
          const products = document.createElement('div');
          products.className = 'tf-milsim__bundle-entry-products';
          selected.ids.forEach((_, index) => {
            const product = this.selectionProduct(selected, index);
            const item = document.createElement(product.url ? 'a' : 'div');
            item.className = 'tf-milsim__selection-product';
            if (product.url) {
              item.href = product.url;
              item.target = '_blank';
              item.rel = 'noopener';
              item.setAttribute('aria-label', this.text('selections_view', 'View {title}', { title: product.title }));
            }
            if (product.image) {
              const image = document.createElement('img');
              image.src = product.image;
              image.alt = '';
              image.width = 42;
              image.height = 42;
              image.loading = 'lazy';
              item.append(image);
            }
            const copy = document.createElement('span');
            copy.className = 'tf-milsim__bundle-entry-copy';
            const name = document.createElement('strong');
            name.textContent = product.title;
            const detail = document.createElement('small');
            const tier = group.element.dataset.milsimOptionCard === 'true'
              ? this.text(selected.option === '2' ? 'selections_premium' : 'selections_standard', selected.option === '2' ? 'Premium' : 'Standard') : '';
            detail.textContent = ['×' + product.quantity, product.color, tier].filter(Boolean).join(' · ');
            copy.append(name, detail);
            item.append(copy);
            products.append(item);
          });
          const price = document.createElement('span');
          price.className = 'tf-milsim__bundle-entry-price';
          price.textContent = this.formatMoney(selected.price);
          const remove = document.createElement('button');
          remove.type = 'button';
          remove.dataset.bundleRemove = id;
          remove.className = 'tf-milsim__bundle-remove';
          remove.textContent = '×';
          remove.setAttribute('aria-label', this.text('remove_label', 'Remove {title} from bundle', { title: selected.titles.join(' + ') }));
          entry.append(products, price, remove);
          list.append(entry);
        });
        category.append(heading, list);
        this.summaryList.append(category);
      });
    }

    clearRewardPulse(tier) {
      const timer = this.rewardPulseTimers?.get(tier);
      if (timer !== undefined) clearTimeout(timer);
      this.rewardPulseTimers?.delete(tier);
      tier.classList.remove('is-reward-unlocking');
    }

    pulseReward(tier) {
      this.clearRewardPulse(tier);
      if (!tier.querySelector('.tf-milsim__reward-preview')) return;
      this.rewardPulseTimers ||= new Map();
      // A rapid remove/re-add is a new crossing, so restart the short visual cue.
      void tier.offsetWidth;
      tier.classList.add('is-reward-unlocking');
      this.rewardPulseTimers.set(tier, setTimeout(() => {
        tier.classList.remove('is-reward-unlocking');
        this.rewardPulseTimers?.delete(tier);
      }, 1200));
    }

    updateRewards() {
      const cents = Math.max(0, this.total());
      const previous = this.rewardPreviousTotal;
      const reducedMotion = typeof matchMedia === 'function' && matchMedia('(prefers-reduced-motion: reduce)').matches;
      const tiers = Array.from(this.querySelectorAll('[data-reward-tier]'));
      const max = Math.max(1, ...tiers.map(tier => Number(tier.dataset.threshold)));
      const progress = this.querySelector('[data-reward-progress]');
      if (progress) { progress.max = max; progress.value = Math.min(cents, max); }
      tiers.forEach(tier => {
        const unlocked = cents >= Number(tier.dataset.threshold);
        tier.classList.toggle('is-unlocked', unlocked);
        if (!unlocked || reducedMotion) this.clearRewardPulse(tier);
        else if (Number.isFinite(previous) && previous < Number(tier.dataset.threshold) && !this.restoring) this.pulseReward(tier);
        const check = tier.querySelector('[data-reward-check]');
        if (check) check.hidden = !unlocked;
        const state = tier.querySelector('[data-reward-state]');
        if (state) state.textContent = this.text(unlocked ? 'reward_unlocked' : 'reward_locked', unlocked ? 'Unlocked' : 'Locked');
        const remaining = tier.querySelector('[data-reward-remaining]');
        if (remaining) remaining.textContent = unlocked
          ? this.text('reward_unlocked', 'Unlocked')
          : this.text('reward_tier_remaining', '{amount} remaining', { amount: this.formatMoney(Math.max(0, Number(tier.dataset.threshold) - cents)) });
      });
      // Hydration/reload establishes a baseline rather than replaying earned rewards.
      this.rewardPreviousTotal = cents;
      const next = tiers.find(tier => cents < Number(tier.dataset.threshold));
      const caption = this.querySelector('[data-reward-next]');
      if (caption) caption.textContent = next
        ? this.text('reward_remaining', '{amount} to unlock {reward}', { amount: this.formatMoney(Number(next.dataset.threshold) - cents), reward: next.dataset.rewardName })
        : this.text('reward_all', 'All rewards unlocked.');
    }

    render() {
      this.syncCarrierAccessories();
      this.groups.forEach((_, id) => this.updateGroupState(id));
      const total = this.formatMoney(this.total());
      this.updateRewards();
      this.querySelectorAll('[data-milsim-current-total]').forEach(element => { element.textContent = total; });
      this.querySelectorAll('[data-bundle-count]').forEach(element => {
        element.textContent = this.text(this.count() === 1 ? 'selected_count_single' : 'selected_count', this.count() === 1 ? '{count} item selected' : '{count} items selected', { count: this.count() });
      });
      this.querySelectorAll('[data-bundle-clear]').forEach(button => {
        button.disabled = this.confirmed.size === 0;
        button.hidden = this.confirmed.size === 0;
      });
      const summary = this.querySelector('[data-bundle-summary]');
      if (summary) { summary.dataset.empty = String(this.confirmed.size === 0); summary.setAttribute('tabindex', '-1'); }
      this.renderSelectionGroups();
      const form = this.querySelector('.tf-milsim__bundle-action [data-milsim-cart-form]');
      if (form) {
        form.dataset.ready = 'false';
        form.querySelectorAll('input[name^="items["]').forEach(input => input.remove());
        let index = 0;
        this.confirmed.forEach(selected => selected.ids.forEach((id, position) => {
          const variant = document.createElement('input');
          variant.type = 'hidden';
          variant.name = `items[${index}][id]`;
          variant.value = id;
          variant.dataset.milsimVariant = '';
          variant.disabled = true;
          const quantity = document.createElement('input');
          quantity.type = 'hidden';
          quantity.name = `items[${index}][quantity]`;
          quantity.value = String(selected.quantities[position]);
          quantity.disabled = true;
          form.append(variant, quantity);
          index += 1;
        }));
        form.dataset.expected = String(index);
      }
      this.querySelectorAll('.tf-milsim__buy-bundle').forEach(button => { button.disabled = true; });
    }

    announce(key, fallback, values = {}) {
      const status = this.querySelector('[data-bundle-status]');
      if (status) status.textContent = this.text(key, fallback, values);
    }

    persist() {
      try {
        const selections = Array.from(this.confirmed, ([id, item]) => ({ id, option: item.option, ids: item.ids, quantities: item.quantities, indices: item.indices }));
        const previews = Array.from(this.groups, ([id, group]) => {
          const viewed = this.readPanel(group.panels.find(panel => !panel.hidden));
          return viewed ? { id, option: viewed.option, ids: viewed.ids, quantities: viewed.quantities, indices: viewed.indices } : null;
        }).filter(Boolean);
        if (selections.length) sessionStorage.setItem(this.storageKey, JSON.stringify({ version: 1, selections, previews }));
        else sessionStorage.removeItem(this.storageKey);
      } catch (_) { /* Selection still works when storage is unavailable. */ }
    }

    restore() {
      this.restoring = true;
      try {
        const saved = JSON.parse(sessionStorage.getItem(this.storageKey) || 'null');
        if (!saved || saved.version !== 1 || !Array.isArray(saved.selections)) return;
        saved.selections.forEach(item => {
          if (!item || typeof item.id !== 'string' || typeof item.option !== 'string') return;
          const group = this.groups.get(item.id);
          const panel = group?.panels.find(panel => panel.dataset.milsimOptionPanel === item.option);
          if (!this.restorePanelVariants(panel, item.ids, item.indices)) return;
          if (item.quantities && !panel.querySelector('[data-bundle-part]') && !this.setPanelQuantities(panel, item.quantities)) return;
          const selected = this.readPanel(panel);
          if (!selected) return;
          if (!Array.isArray(item.ids) || !Array.isArray(item.quantities)
            || JSON.stringify(item.ids) !== JSON.stringify(selected.ids)
            || JSON.stringify(item.quantities) !== JSON.stringify(selected.quantities)) return;
          this.confirmed.set(item.id, selected);
          this.preview(item.id, item.option);
        });
        if (Array.isArray(saved.previews)) saved.previews.forEach(item => {
          const group = this.groups.get(item?.id);
          if (!group) return;
          const panel = group.panels.find(panel => panel.dataset.milsimOptionPanel === item.option);
          if (!this.restorePanelVariants(panel, item.ids, item.indices)) return;
          if (item.quantities && !panel.querySelector('[data-bundle-part]') && !this.setPanelQuantities(panel, item.quantities)) return;
          const viewed = this.readPanel(panel);
          if (viewed && JSON.stringify(item.ids) === JSON.stringify(viewed.ids)) this.preview(item.id, item.option);
        });
        this.syncCarrierAccessories();
        this.persist();
      } catch (_) { /* Ignore stale or inaccessible saved state. */ }
      finally { this.restoring = false; }
    }

    disconnectedCallback() {
      this.layoutObserver?.disconnect();
      this.layoutObserver = null;
      this.rewardPulseTimers?.forEach((_, tier) => this.clearRewardPulse(tier));
      this.rewardPulseTimers?.clear();
      this.rewardPreviousTotal = null;
      this.addonTimers?.forEach(timer => clearTimeout(timer));
      this.addonTimers?.clear();
      this.builderAbort?.abort();
      this.builderAbort = null;
      this.groups = null;
      this.confirmed = null;
      this.colorPanels = null;
    }
  });
}

/* Independent turntable component for the Milsim section. */
if (!customElements.get('tf-milsim-turntable')) {
  // Optional per-view alignment: percentages of the frame box, uniform scale, horizontal flip.
  // Views: front, front-right, right, back-right, back, back-left, left, front-left.
  const FRAME_OFFSETS = [[-7.32, .96], [7.84, .65], [-11.51, -.10], [1.31, .05], [-8.09, .78], [7.31, .18], [-6.92, 1.35], [6.66, 1.27]];
  const FRAME_SCALES = [1.0197, 1.0134, .998, 1.001, 1.0103, .998, 1.0228, 1.0260];
  const FRAME_FLIP_X = [false, false, false, false, false, false, false, false];

  customElements.define('tf-milsim-turntable', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.root = this.closest('.tf-milsim');
      this.surface = this.querySelector('[data-turn-surface]');
      this.sprite = this.querySelector('[data-turn-frame]');
      this.front = this.querySelector('.tf-milsim__hologram');
      this.range = this.querySelector('[data-turn-range]');
      this.output = this.querySelector('[data-turn-output]');
      this.reset = this.querySelector('[data-turn-reset]');
      this.hint = this.querySelector('[data-turn-hint]');
      if (!this.root || !this.surface || !this.sprite || !this.front || !this.range || !this.reset || !this.output || !this.hint) return;
      try { this.labels = JSON.parse(this.querySelector('[data-turn-i18n]')?.textContent || '{}'); }
      catch { return; }
      if (!Array.isArray(this.labels.angles) || this.labels.angles.length !== 9 ||
          !['output', 'value', 'surface', 'ready', 'unavailable'].every(key => typeof this.labels[key] === 'string')) return;
      this.angleLabels = this.labels.angles;
      this.frame = 0;
      this.ready = false;
      this.images = [];
      this.pairs = null;
      this.sourceMode = 'loading';
      this.dataset.source = 'loading';
      this.dataset.ready = 'false';
      this.range.disabled = true;
      this.reset.disabled = true;
      this.renderFrame(0);
      this.range.addEventListener('input', () => this.renderFrame(Number(this.range.value)), { signal });
      this.reset.addEventListener('click', () => this.renderFrame(0), { signal });
      this.surface.addEventListener('keydown', (event) => {
        if (!this.ready) return;
        let next;
        if (event.key === 'ArrowRight') next = this.frame + 1;
        else if (event.key === 'ArrowLeft') next = this.frame - 1;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = 8;
        else return;
        event.preventDefault();
        this.renderFrame(next);
      }, { signal });
      this.surface.addEventListener('pointerdown', (event) => {
        if (!this.ready || !event.isPrimary || event.button !== 0) return;
        this.drag = { id: event.pointerId, x: event.clientX, y: event.clientY, frame: this.frame, active: false };
      }, { signal });
      this.surface.addEventListener('pointermove', (event) => {
        const drag = this.drag;
        if (!drag || event.pointerId !== drag.id) return;
        const dx = event.clientX - drag.x;
        const dy = event.clientY - drag.y;
        if (!drag.active) {
          if (Math.abs(dy) > Math.abs(dx) && Math.abs(dy) > 7) { this.stopDrag(); return; }
          if (Math.abs(dx) < 7) return;
          drag.active = true;
          this.surface.setPointerCapture(event.pointerId);
          this.classList.add('is-dragging');
        }
        if (event.cancelable) event.preventDefault();
        const pixelsPerFrame = Math.max(28, this.surface.clientWidth / 8);
        this.renderFrame(drag.frame + Math.round(dx / pixelsPerFrame));
      }, { signal });
      for (const name of ['pointerup', 'pointercancel', 'lostpointercapture']) {
        this.surface.addEventListener(name, () => this.stopDrag(), { signal });
      }
      this.surface.addEventListener('pointerleave', () => { if (this.drag && !this.drag.active) this.stopDrag(); }, { signal });
      this.loadMedia(signal);
    }
    loadImage(url, signal) {
      return new Promise((resolve, reject) => {
        if (signal.aborted || !url) { reject(new Error('Image unavailable')); return; }
        const image = new Image();
        this.images.push(image);
        const cleanup = () => {
          image.onload = null;
          image.onerror = null;
          signal.removeEventListener('abort', onAbort);
        };
        const fail = () => { cleanup(); reject(new Error('Image unavailable')); };
        const onAbort = () => fail();
        image.onload = () => {
          if (signal.aborted || !this.isConnected) { fail(); return; }
          // Each transparent 2x1 pair has a 4:3 overall ratio.
          const ratio = image.naturalWidth / image.naturalHeight;
          if (!image.naturalWidth || !image.naturalHeight || Math.abs(ratio - 4 / 3) > 0.035) { fail(); return; }
          cleanup();
          resolve(image);
        };
        image.onerror = fail;
        signal.addEventListener('abort', onAbort, { once: true });
        image.src = url;
      });
    }
    async loadMedia(signal) {
      let urls;
      try { urls = JSON.parse(this.dataset.pairs || 'null'); }
      catch { urls = null; }
      if (Array.isArray(urls) && urls.length === 4 && urls.every(url => typeof url === 'string' && url.trim())) {
        try {
          const pairs = await Promise.all(urls.map(url => this.loadImage(url, signal)));
          if (signal.aborted || !this.isConnected) return;
          this.pairs = pairs;
          this.markReady('pairs');
          return;
        } catch {
          if (signal.aborted || !this.isConnected) return;
        }
      }
      if (!signal.aborted && this.isConnected) this.failMedia();
    }
    markReady(mode) {
      this.sourceMode = mode;
      this.dataset.source = mode;
      this.ready = true;
      this.dataset.ready = 'true';
      this.range.disabled = false;
      this.reset.disabled = false;
      this.hint.textContent = this.labels.ready;
      this.renderFrame(this.frame);
    }
    renderFrame(raw) {
      const value = Number.isFinite(raw) ? Math.round(raw) : 0;
      const wrapped = ((value % 8) + 8) % 8;
      this.frame = wrapped;
      const displayValue = value === 8 ? 8 : wrapped;
      this.range.value = String(displayValue);
      const degrees = displayValue * 45;
      const format = (text) => text.replaceAll('[angle]', this.angleLabels[displayValue]).replaceAll('[degrees]', String(degrees));
      this.output.textContent = format(this.labels.output);
      this.range.setAttribute('aria-valuetext', format(this.labels.value));
      // Keep the transparent front visible until every rotation pair is ready.
      const showSprite = this.ready && this.sourceMode === 'pairs';
      this.front.hidden = showSprite;
      this.sprite.hidden = !showSprite;
      if (showSprite) {
        const image = this.pairs[Math.floor(wrapped / 2)];
        this.sprite.style.backgroundImage = `url(${JSON.stringify(image.src)})`;
        this.sprite.style.backgroundSize = '200% 100%';
        this.sprite.style.backgroundPosition = `${(wrapped % 2) * 100}% 0%`;
        const [x, y] = FRAME_OFFSETS[wrapped];
        const scale = FRAME_SCALES[wrapped];
        const flip = FRAME_FLIP_X[wrapped] ? -1 : 1;
        this.sprite.style.transform = `translate(-50%, -50%) translate(${x}%, ${y}%) scale(${scale}) scaleX(${flip})`;
      }
      this.root.dataset.milsimView = showSprite && wrapped !== 0 ? 'angled' : 'front';
      this.surface.setAttribute('aria-label', format(this.labels.surface));
      this.dispatchEvent(new CustomEvent('milsim:viewchange', { bubbles: true, detail: { frame: wrapped, degrees } }));
    }
    stopDrag() {
      const id = this.drag?.id;
      this.drag = null;
      this.classList.remove('is-dragging');
      if (id !== undefined && this.surface?.hasPointerCapture(id)) this.surface.releasePointerCapture(id);
    }
    failMedia() {
      this.ready = false;
      this.sourceMode = 'front';
      this.dataset.source = 'front';
      this.dataset.ready = 'false';
      this.range.disabled = true;
      this.reset.disabled = true;
      this.renderFrame(0);
      this.hint.textContent = this.labels.unavailable;
    }
    disconnectedCallback() {
      this.stopDrag();
      this.abort?.abort();
      this.abort = null;
      for (const image of this.images || []) { image.onload = null; image.onerror = null; }
      this.images = [];
      this.pairs = null;
      this.ready = false;
      if (this.root) delete this.root.dataset.milsimView;
    }
  });
}



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tf-starter-loadout"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tf-starter-cart')) {
  customElements.define('tf-starter-cart', class extends HTMLElement {
    connectedCallback() {
      if (this.handleSubmit) return;
      this.pending = false;
      let strings = {};
      try { strings = JSON.parse(this.querySelector('[data-starter-i18n]')?.textContent || '{}'); } catch (_) {}
      const text = (key, fallback) => strings[key] || fallback;
      const bundleButton = this.querySelector('[data-starter-cart-form][data-ready="true"] .tf-starter__buy-bundle');
      if (bundleButton) bundleButton.disabled = false;
      this.handleSubmit = async (event) => {
        const form = event.target.closest('[data-starter-cart-form]');
        if (!form || !this.contains(form)) return;
        event.preventDefault();
        const button = form.querySelector('button[type="submit"]');
        if (this.pending || !button || button.disabled || form.dataset.ready !== 'true') return;
        const ids = Array.from(form.querySelectorAll('[data-starter-variant]'), input => input.value);
        const status = form.querySelector('[data-starter-message]');
        const review = form.querySelector('[data-starter-review]');
        const showError = (message) => {
          status.hidden = false;
          status.textContent = message;
          review.hidden = false;
        };
        if (!ids.length || ids.length !== Number(form.dataset.expected) || new Set(ids).size !== ids.length || ids.some(id => !/^\d+$/.test(id))) {
          showError(text('notReady', 'This selection is not ready to order. Please review the items.'));
          return;
        }
        this.pending = true;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        status.hidden = false;
        status.textContent = text('adding', 'Adding to basket…');
        review.hidden = true;
        try {
          const response = await fetch(form.action.replace(/\/$/, '') + '.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: ids.map(id => ({ id, quantity: 1 })) })
          });
          const result = await response.json();
          if (!response.ok || result.status >= 400) {
            const detail = typeof result.description === 'string' ? result.description + ' ' : '';
            throw new Error(detail + text('review', 'Please review your basket before trying again.'));
          }
          if (!Array.isArray(result.items) || result.items.length !== ids.length) {
            throw new Error(text('incomplete', 'We could not confirm the complete addition. Please review your basket before trying again.'));
          }
          status.textContent = text('added', 'Added. Opening your basket…');
          window.location.assign(this.dataset.cartUrl);
        } catch (error) {
          const detail = error instanceof Error && error.message ? error.message : text('unable', 'Unable to confirm the addition.');
          showError(detail.includes(text('review', 'Please review your basket before trying again.')) ? detail : text('failed', 'Unable to confirm the addition. Please review your basket before trying again.'));
          this.pending = false;
          button.disabled = false;
          button.removeAttribute('aria-busy');
        }
      };
      this.addEventListener('submit', this.handleSubmit);
    }
    disconnectedCallback() {
      this.removeEventListener('submit', this.handleSubmit);
      this.handleSubmit = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tf-team-community"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tf-team-community')) {
    class TfTeamCommunity extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.setupFrame = requestAnimationFrame(() => this.setup());
      }

      setup() {
        if (!this.isConnected || this.controller.signal.aborted) return;
        this.dialog = this.querySelector('[data-tf-viewer]');
        this.photos = Array.from(this.querySelectorAll('[data-tf-photo]'));
        if (!this.dialog || !this.photos.length || typeof this.dialog.showModal !== 'function') return;

        const signal = this.controller.signal;
        this.stage = this.querySelector('[data-tf-stage]');
        this.error = this.querySelector('[data-tf-error]');
        this.captionTitle = this.querySelector('[data-tf-title]');
        this.copy = this.querySelector('[data-tf-copy]');
        this.original = this.querySelector('[data-tf-original]');
        this.counter = this.querySelector('[data-tf-counter]');
        this.status = this.querySelector('[data-tf-status]');
        this.previous = this.querySelector('[data-tf-previous]');
        this.next = this.querySelector('[data-tf-next]');

        this.photos.forEach((photo) => {
          photo.setAttribute('aria-haspopup', 'dialog');
          photo.addEventListener('click', (event) => {
            if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
            this.opener = photo;
            this.activePhotos = this.photos.filter((item) => item.dataset.album === photo.dataset.album);
            this.previous.disabled = this.activePhotos.length < 2;
            this.next.disabled = this.activePhotos.length < 2;
            this.showPhoto(this.activePhotos.indexOf(photo));
            try {
              this.dialog.showModal();
            } catch (error) {
              return;
            }
            event.preventDefault();
            this.lockScroll();
            this.querySelector('[data-tf-close]').focus({ preventScroll: true });
          }, { signal });
        });
        this.querySelector('[data-tf-close]').addEventListener('click', () => this.dialog.close(), { signal });
        this.previous.addEventListener('click', () => this.showPhoto(this.index - 1), { signal });
        this.next.addEventListener('click', () => this.showPhoto(this.index + 1), { signal });
        this.previous.disabled = true;
        this.next.disabled = true;
        this.dialog.addEventListener('keydown', (event) => {
          if (event.altKey || event.ctrlKey || event.metaKey) return;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            this.showPhoto(this.index + (event.key === 'ArrowRight' ? 1 : -1));
          }
        }, { signal });
        this.dialog.addEventListener('cancel', (event) => {
          event.preventDefault();
          this.dialog.close();
        }, { signal });
        this.dialog.addEventListener('click', (event) => {
          if (event.target !== this.dialog) return;
          const bounds = this.dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
        }, { signal });
        this.dialog.addEventListener('close', () => this.restorePage(), { signal });
        document.addEventListener('shopify:section:unload', (event) => {
          if (event.detail?.sectionId === this.dataset.sectionId) this.teardown();
        }, { signal });
      }

      showPhoto(index) {
        if (!this.activePhotos?.length) return;
        this.index = (index + this.activePhotos.length) % this.activePhotos.length;
        const photo = this.activePhotos[this.index];
        const counter = `${this.index + 1} ${this.dataset.counterOf} ${this.activePhotos.length}`;
        this.imageController?.abort();
        this.imageController = new AbortController();
        this.stage.querySelector('img')?.remove();
        this.error.hidden = true;

        const image = new Image();
        image.className = 'tf-team-community__viewer-image';
        image.alt = photo.dataset.alt || '';
        image.width = Number(photo.dataset.width);
        image.height = Number(photo.dataset.height);
        image.decoding = 'async';
        image.addEventListener('error', () => {
          image.hidden = true;
          this.error.hidden = false;
        }, { once: true, signal: this.imageController.signal });
        image.src = photo.href;
        this.stage.append(image);

        this.captionTitle.textContent = photo.dataset.title || '';
        this.copy.textContent = photo.dataset.copy || '';
        this.copy.hidden = !photo.dataset.copy;
        this.original.href = photo.href;
        this.counter.textContent = counter;
        this.status.textContent = `${counter}: ${photo.dataset.title || ''}`;
      }

      lockScroll() {
        if (this.scrollState) return;
        const root = document.documentElement;
        const body = document.body;
        const scrollbar = Math.max(0, window.innerWidth - root.clientWidth);
        this.scrollState = {
          x: window.scrollX,
          y: window.scrollY,
          rootOverflow: root.style.overflow,
          position: body.style.position,
          top: body.style.top,
          left: body.style.left,
          width: body.style.width,
          boxSizing: body.style.boxSizing,
          paddingRight: body.style.paddingRight
        };
        const padding = parseFloat(getComputedStyle(body).paddingRight) || 0;
        root.style.overflow = 'hidden';
        body.style.position = 'fixed';
        body.style.top = `${-this.scrollState.y}px`;
        body.style.left = `${-this.scrollState.x}px`;
        body.style.width = '100%';
        body.style.boxSizing = 'border-box';
        if (scrollbar) body.style.paddingRight = `${padding + scrollbar}px`;
      }

      restorePage() {
        const state = this.scrollState;
        if (state) {
          this.scrollState = null;
          document.documentElement.style.overflow = state.rootOverflow;
          for (const property of ['position', 'top', 'left', 'width', 'boxSizing', 'paddingRight']) document.body.style[property] = state[property];
          window.scrollTo({ left: state.x, top: state.y, behavior: 'instant' });
        }
        if (this.opener?.isConnected) this.opener.focus({ preventScroll: true });
        this.opener = null;
      }

      teardown() {
        cancelAnimationFrame(this.setupFrame);
        this.controller?.abort();
        this.imageController?.abort();
        if (this.dialog?.open) this.dialog.close();
        this.restorePage();
        this.photos?.forEach((photo) => photo.removeAttribute('aria-haspopup'));
      }

      disconnectedCallback() {
        this.teardown();
      }
    }
    customElements.define('tf-team-community', TfTeamCommunity);
  }

  if (!customElements.get('tf-rhodes-showcase')) {
    class TfRhodesShowcase extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.setupFrame = requestAnimationFrame(() => this.setup());
      }

      setup() {
        if (!this.isConnected || this.controller.signal.aborted) return;
        this.slides = Array.from(this.querySelectorAll('[data-rhodes-slide]'));
        this.thumbnails = Array.from(this.querySelectorAll('[data-rhodes-thumbnail]'));
        if (this.slides.length < 2) return;
        const signal = this.controller.signal;
        this.index = 0;
        this.count = this.querySelector('[data-rhodes-count]');
        this.status = this.querySelector('[data-rhodes-status]');
        this.rail = this.querySelector('[data-rhodes-thumbnails]');
        this.stage = this.querySelector('[data-rhodes-stage]');
        this.querySelector('[data-rhodes-navigation]').hidden = false;
        this.rail.hidden = false;
        this.thumbnails.forEach((button, index) => button.addEventListener('click', () => this.show(index), { signal }));
        this.querySelector('[data-rhodes-previous]').addEventListener('click', () => this.show(this.index - 1), { signal });
        this.querySelector('[data-rhodes-next]').addEventListener('click', () => this.show(this.index + 1), { signal });
        this.addEventListener('keydown', event => {
          if (event.altKey || event.ctrlKey || event.metaKey || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          if (!event.target.closest('button')) return;
          event.preventDefault();
          let index = this.index + (event.key === 'ArrowRight' ? 1 : -1);
          if (event.key === 'Home') index = 0;
          if (event.key === 'End') index = this.slides.length - 1;
          this.show(index);
          if (event.target.hasAttribute('data-rhodes-thumbnail')) this.thumbnails[this.index].focus({ preventScroll: true });
        }, { signal });
        this.stage.addEventListener('pointerdown', event => {
          if (event.pointerType === 'mouse' || !event.target.closest('.tf-rhodes-showcase__image')) return;
          this.startPoint = { x: event.clientX, y: event.clientY, id: event.pointerId };
        }, { signal });
        this.stage.addEventListener('pointerup', event => {
          const start = this.startPoint;
          this.startPoint = null;
          if (!start || start.id !== event.pointerId) return;
          const dx = event.clientX - start.x;
          const dy = event.clientY - start.y;
          if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5) this.show(this.index + (dx < 0 ? 1 : -1));
        }, { signal });
        this.stage.addEventListener('pointercancel', () => { this.startPoint = null; }, { signal });
        document.addEventListener('shopify:block:select', event => {
          const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail?.blockId);
          if (index >= 0) this.show(index);
        }, { signal });
      }

      show(index) {
        this.index = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; });
        this.thumbnails.forEach((button, i) => {
          if (i === this.index) button.setAttribute('aria-current', 'true');
          else button.removeAttribute('aria-current');
        });
        this.count.textContent = String(this.index + 1).padStart(2, '0');
        const title = this.slides[this.index].dataset.title || '';
        this.status.textContent = (this.index + 1) + ' ' + this.dataset.counterOf + ' ' + this.slides.length + ': ' + title;
        const selected = this.thumbnails[this.index];
        const selectedBounds = selected.getBoundingClientRect();
        const railBounds = this.rail.getBoundingClientRect();
        const delta = selectedBounds.left < railBounds.left ? selectedBounds.left - railBounds.left - 4 : selectedBounds.right > railBounds.right ? selectedBounds.right - railBounds.right + 4 : 0;
        if (delta) this.rail.scrollBy({ left: delta, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.setupFrame);
        this.controller?.abort();
      }
    }
    customElements.define('tf-rhodes-showcase', TfRhodesShowcase);
  }

  } catch(e) { console.error(e); }
})();
})();
